import styled from 'styled-components';
import { ColorAddiWhite } from '@addi/foundation/dist/web/colors';
export const Background = styled.div `
  background-color: ${ColorAddiWhite};
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 15%;
    min-width: 100px;
  }
`;
//# sourceMappingURL=SimpleLoader.styled.js.map